import {
    Box, useTheme, Chip, List, ListItem, ListItemText, Divider, Card, CardContent, Typography, IconButton, Tooltip,
} from "@mui/material";
import FolderIcon from '@mui/icons-material/ArrowCircleRightOutlined';
import DescriptionIcon from '@mui/icons-material/Description';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListAltIcon from '@mui/icons-material/ListAlt';
import React, { useState } from 'react';

import 'react-toastify/dist/ReactToastify.css';
import Report from '@mui/icons-material/Article';
import Header from "../../../Layout/Header";
import AssessmentIcon from '@mui/icons-material/Assessment';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';

import FinishedParentRollList from "../reports/FinshedParentRoll";
import FGStockReport from "../reports/FGStockReport";
import QCDataCollection from "../reports/QCDataCollection";
import GenerateQCDataByFilterData from "../reports/GenerateQCDataByFilterData";
import JumboReport from "../reports/JumboReport";
import MenuIcon from "@mui/icons-material/Menu";
import ReportsHeader from "../../../components/ReportHeader";
import WIPChildReelReport from "../reports/WIPReport";
import FGChildReelReport from "../reports/FGChildReelReport";
import SheetCuttingReport from "../reports/SheetCuttingReport";
import ReamBundleReport from "../reports/ReamBundleReport";
import ReelPendingConversionReport from "../reports/ReelPendingConvertionReport";
import ReamBundlePendingConversionReport from "../reports/ReamBundlePendingConvertionReport";


import ChildReelWiseReamProductionReport from "../reports/ChildReelWiseReamProductionReport";
import ReportParentRollProductionMAWiseBalanceQty from "../reports/ParentRollMAWiseBalanceQty";
import ReWinderDetailReport from "../reports/ReWinderDetailReport";
import { tokens } from "../../../theme/theme";
import AddQCPropertyMaster from "../../master/AddQCPropertyMaster";
import { FolderOff, FolderOpen, FolderOpenRounded, FolderOpenTwoTone } from "@mui/icons-material";
import WarehouseMasterDataReport from "../../warehousenew/warehouse-data-report/WarehouseDataReport";
import ProductionSummary from "../reports/ProductionSummary";

const ProductionReports = ({ handleBackWinderMachineEntry }) => {

    const [value, setValue] = React.useState(0);
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [reportHeader, setReportHeader] = useState('');

    const [reportStates, setReportStates] = useState({
        Report_All: true,
        Report_SalesOrder: false,
        Report_FGStock: false,
        Report_QCData: false,
        Report_GenerateQCDataGivenSize: false,
        Report_JumboDetailReport: false,
        Report_WIPChildReelDetailReport: false,
        Report_FGChildReelDetailReport: false,
        Report_SheetCuttingReport: false,
        Report_ReamBundleReport: false,
        Report_ChildRollWiseReamProductionReport: false,
        Report_OrderwiseReelPendingConversionReport: false,
        Report_ReamBundlePendingConversionReport: false,
        Report_ParentRollProductionMaWiseBalancePlanQuantity: false,
        Report_ReWinderDetailReport: false,
        Report_QCPropertyMaster: false
    });

    const handleViewReport = (reportType, reportKey) => () => {
        const defaultState = {
            Report_All: false,
            Report_SalesOrder: false,
            Report_FGStock: false,
            Report_QCData: false,
            Report_GenerateQCDataGivenSize: false,
            Report_JumboDetailReport: false,
            Report_WIPChildReelDetailReport: false,
            Report_FGChildReelDetailReport: false,
            Report_SheetCuttingReport: false,
            Report_ReamBundleReport: false,
            Report_ChildRollWiseReamProductionReport: false,
            Report_OrderwiseReelPendingConversionReport: false,
            Report_ReamBundlePendingConversionReport: false,
            Report_ParentRollProductionMaWiseBalancePlanQuantity: false,
            Report_ReWinderDetailReport: false,
            Report_QCPropertyMaster: false
        };

        // Update only the selected report key
        setReportStates({ ...defaultState, [reportKey]: true });
        setReportHeader(`${reportType} Report`);
    };


    //////////////////////////////////////////////////////////////////////////////////////////////////
    const handletabChange = (index) => {
        setValue(index);

        let reportKey = "Report_All";
        const defaultState = {
            Report_All: false,
            Report_SalesOrder: false,
            Report_FGStock: false,
            Report_QCData: false,
            Report_GenerateQCDataGivenSize: false,
            Report_JumboDetailReport: false,
            Report_WIPChildReelDetailReport: false,
            Report_FGChildReelDetailReport: false,
            Report_SheetCuttingReport: false,
            Report_ReamBundleReport: false,
            Report_ChildRollWiseReamProductionReport: false,
            Report_OrderwiseReelPendingConversionReport: false,
            Report_ReamBundlePendingConversionReport: false,
            Report_ParentRollProductionMaWiseBalancePlanQuantity: false,
            Report_ReWinderDetailReport: false,
            Report_QCPropertyMaster: false
        };

        // Update only the selected report key
        setReportStates({ ...defaultState, [reportKey]: true });
    };

    // tab contents 
    const tabNames = [
        'Paper Roll Production',
        'Child Roll Production',
        'Cutter Production',
        'Pending Conversion Report',
        'Stock Details',
        'QC Certificate',
        'Production Tracking Report',
        'Production Summary Report',
    ];

    const TabContent = ({ index }) => {
        switch (index) {
            case 0:
                return <Box p={2}>
                    <Card style={{ backgroundColor: "transparent" }}>
                        <Box flexDirection={'row'} p={'10px'}>
                            <ReportsHeader title={'Parent Roll Production'} subtitle="" callback={handleBackWinderMachineEntry} />
                        </Box>
                        <Divider />

                        <CardContent>
                            <Box display="flex" flexDirection={'column'}>
                                <Box display="flex" flexDirection={'row'}>
                                    <IconButton style={{ borderRadius: '8px', }} onClick={handleViewReport('Jumbo Roll Detail Report', 'Report_JumboDetailReport')}>
                                        <Report fontSize="small" style={{ marginRight: '5px', color: '#1e88e5' }} />
                                        <Typography variant="button" textTransform={'none'} fontSize={13}  >Jumbo Roll Production Detail Report</Typography>
                                    </IconButton>
                                </Box>
                            </Box>

                            <Box display="flex" flexDirection={'row'}>
                                <IconButton style={{ borderRadius: '8px', }} onClick={handleViewReport('View MA Wise Balance Plan Quantity', 'Report_ParentRollProductionMaWiseBalancePlanQuantity')} >
                                    <Report fontSize="small" style={{ marginRight: '5px', color: '#1e88e5' }} />
                                    <Typography variant="button" textTransform={'none'} fontSize={13} >Find MA Wise Balance Plan Quantity </Typography>
                                </IconButton>
                            </Box>

                        </CardContent>
                    </Card>
                </Box>;
            case 1:
                return <Box p={2}>
                    <Card style={{ backgroundColor: "transparent" }}>
                        <Box flexDirection={'row'} p={'10px'}>
                            <ReportsHeader title={'Child Roll Production'} subtitle="" callback={handleBackWinderMachineEntry} />
                        </Box>

                        <Divider />

                        <CardContent>
                            <Box display="flex" flexDirection={'column'}>
                                <Box display="flex" flexDirection={'row'}>
                                    <IconButton style={{ borderRadius: '8px', }} onClick={handleViewReport('WIP Child Roll Detail Report', 'Report_WIPChildReelDetailReport')} >
                                        <Report fontSize="small" style={{ marginRight: '5px', color: '#1e88e5' }} />
                                        <Typography variant="button" textTransform={'none'} fontSize={13} >Rewinder Production Detail Report</Typography>
                                    </IconButton>
                                </Box>

                                <Box display="flex" flexDirection={'row'}>
                                    <IconButton style={{ borderRadius: '8px', }} onClick={handleViewReport('FG Child Roll Detail Report', 'Report_FGChildReelDetailReport')} >
                                        <Report fontSize="small" style={{ marginRight: '5px', color: '#1e88e5' }} />
                                        <Typography variant="button" textTransform={'none'} fontSize={13} >Reel Production Detail Report </Typography>
                                    </IconButton>
                                </Box>

                                <Box display="flex" flexDirection={'row'}>
                                    <IconButton style={{ borderRadius: '8px', }} onClick={handleViewReport('Re-Winder Detail Report', 'Report_ReWinderDetailReport')} >
                                        <Report fontSize="small" style={{ marginRight: '5px', color: '#1e88e5' }} />
                                        <Typography variant="button" textTransform={'none'} fontSize={13} >WIP Child Reel Production Detail Report</Typography>
                                    </IconButton>
                                </Box>
                            </Box>
                        </CardContent>
                    </Card>
                </Box>;
            case 2:
                return <Box p={2}>
                    <Card style={{ backgroundColor: "transparent" }}>
                        <Box flexDirection={'row'} p={'10px'}>
                            <ReportsHeader title={'Cutter Production'} subtitle="" callback={handleBackWinderMachineEntry} />
                        </Box>
                        <Divider />
                        <CardContent>
                            <Box display="flex" flexDirection={'column'}>
                                <Box display="flex" flexDirection={'row'}>
                                    <IconButton style={{ borderRadius: '8px', }} onClick={handleViewReport('Sheet Cutting Report', 'Report_SheetCuttingReport')} >
                                        <Report fontSize="small" style={{ marginRight: '5px', color: '#1e88e5' }} />
                                        <Typography variant="button" textTransform={'none'} fontSize={13}>Sheet Cutting Production Detail Report</Typography>
                                    </IconButton>
                                </Box>

                                <Box display="flex" flexDirection={'row'}>
                                    <IconButton style={{ borderRadius: '8px', }} onClick={handleViewReport('Ream Bundle Production Report', 'Report_ReamBundleReport')} >
                                        <Report fontSize="small" style={{ marginRight: '5px', color: '#1e88e5' }} />
                                        <Typography variant="button" textTransform={'none'} fontSize={13}>Bundle and Pallet Production Detail Report</Typography>
                                    </IconButton>
                                </Box>

                                <Box display="flex" flexDirection={'row'}>
                                    <IconButton style={{ borderRadius: '8px', }} onClick={handleViewReport('Child Roll Wise Ream Production Report', 'Report_ChildRollWiseReamProductionReport')} >
                                        <Report fontSize="small" style={{ marginRight: '5px', color: '#1e88e5' }} />
                                        <Typography variant="button" textTransform={'none'} fontSize={13}>Ream Production Detail Report</Typography>
                                    </IconButton>
                                </Box>
                            </Box>
                        </CardContent>
                    </Card>
                </Box>;

            case 3:
                return <Box p={2}>
                    <Card style={{ backgroundColor: "transparent" }}>
                        <Box flexDirection={'row'} p={'10px'}>
                            <ReportsHeader title={'Pending Conversion Report'} subtitle="" callback={handleBackWinderMachineEntry} />
                        </Box>
                    </Card>
                    <Divider />
                    <Card style={{ backgroundColor: "transparent", marginTop: "0px" }}>
                        <CardContent>
                            <Box display="flex" flexDirection={'column'}>
                                <Box display="flex" flexDirection={'row'}>
                                    <IconButton style={{ borderRadius: '8px', }} onClick={handleViewReport('Order Wise Reel Pending Conversion Report', 'Report_OrderwiseReelPendingConversionReport')} >
                                        <Report fontSize="small" style={{ marginRight: '5px', color: '#1e88e5' }} />
                                        <Typography variant="button" textTransform={'none'} fontSize={13}>Order Wise Reel Pending Conversion Report</Typography>
                                    </IconButton>
                                </Box>
                            </Box>

                            <Box display="flex" flexDirection={'column'}>
                                <Box display="flex" flexDirection={'row'}>
                                    <IconButton style={{ borderRadius: '8px', }} onClick={handleViewReport('Order Wise Ream/Bundle Pending Conversion Report', 'Report_ReamBundlePendingConversionReport')} >
                                        <Report fontSize="small" style={{ marginRight: '5px', color: '#1e88e5' }} />
                                        <Typography variant="button" textTransform={'none'} fontSize={13}>Order Wise Ream/Bundle Pending Conversion Report</Typography>
                                    </IconButton>
                                </Box>
                            </Box>
                        </CardContent>
                    </Card>
                </Box>;
            case 4:
                return <Box p={2}>
                    <Card style={{ backgroundColor: "transparent" }}>
                        <Box p={'10px'}>
                            <ReportsHeader title={'Stock Details'} subtitle="" callback={handleBackWinderMachineEntry} />
                        </Box>
                    </Card>
                    <Divider />
                    <Card style={{ backgroundColor: "transparent", marginTop: "0px" }}>
                        <CardContent>

                            <Box display="flex" flexDirection={'column'}>
                                <Box display="flex" flexDirection={'row'}>
                                    <IconButton style={{ borderRadius: '8px', }} onClick={handleViewReport('FG Stock Report', 'Report_FGStock')} >
                                        <Report fontSize="small" style={{ marginRight: '5px', color: '#1e88e5' }} />
                                        <Typography variant="button" textTransform={'none'} fontSize={13}>Finished Goods Stock Report</Typography>
                                    </IconButton>
                                </Box>
                            </Box>
                        </CardContent>
                    </Card>
                </Box>;



            case 5:
                return <Box p={2}>
                    <Card style={{ backgroundColor: "transparent" }}>
                        <Box p={'10px'}>
                            <ReportsHeader title={'QC Certificate'} subtitle="" callback={handleBackWinderMachineEntry} />
                        </Box>
                        <Divider />
                        <CardContent>
                            <Box display="flex" flexDirection={'column'}>
                                <Box display="flex" flexDirection={'row'}>
                                    <IconButton style={{ borderRadius: '8px', }} onClick={handleViewReport('QC Data Collection - (Excel Upload)', 'Report_QCData')} >
                                        <Report fontSize="small" style={{ marginRight: '5px', color: '#1e88e5' }} />
                                        <Typography variant="button" textTransform={'none'} fontSize={13} >QC Data Overview and Excel Upload</Typography>
                                    </IconButton>
                                </Box>
                                <Box display="flex" flexDirection={'row'}>
                                    <IconButton style={{ borderRadius: '8px', }} onClick={handleViewReport('Generate QC certificates for given size', 'Report_GenerateQCDataGivenSize')}>
                                        <Report fontSize="small" style={{ marginRight: '5px', color: '#1e88e5' }} />
                                        <Typography variant="button" textTransform={'none'} fontSize={13} > Generate QC certificates for given Order No and Invoice No</Typography>
                                    </IconButton>
                                </Box>


                            </Box>
                        </CardContent>
                    </Card>
                </Box>;
            case 6:
                return <Box p={2}>
                    <Card style={{ backgroundColor: "transparent" }}>
                        <Box
                            sx={{
                                backgroundColor: "transparent",
                                // overflowX: "auto",
                                overflowY: "auto",
                                // maxHeight: "80vh",
                                whiteSpace: "nowrap",
                                maxWidth: {
                                    xs: "300px",
                                    sm: "500px",
                                    md: "800px",
                                    lg: "1250px",
                                    xl: "1700px"
                                }
                            }}
                        >
                            <WarehouseMasterDataReport handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
                        </Box>


                    </Card>
                </Box>;
                case 7:
                return <Box p={2}>
                    <Card style={{ backgroundColor: "transparent" }}>
                        <Box
                            sx={{
                                backgroundColor: "transparent",
                                // overflowX: "auto",
                                overflowY: "auto",
                                // maxHeight: "80vh",
                                whiteSpace: "nowrap",
                                // maxWidth: {
                                //     xs: "300px",
                                //     sm: "500px",
                                //     md: "800px",
                                //     lg: "1100px",
                                //     xl: "1700px"
                                // }
                            }}
                        >
                            <ProductionSummary handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
                        </Box>


                    </Card>
                </Box>;
            default:
                return null;
        }
    };
    const [isVisible, setIsVisible] = useState(true);
    return (
        <Box >
            <Header title={'Production MIS Reports'} subtitle="" callback={handleBackWinderMachineEntry} />
            <Divider />
            <div >
                <Box display="flex">
                    <Box display="flex" flexDirection={'column'}>
                        <Box display="flex" alignItems="center">


                            <IconButton onClick={() => setIsVisible(!isVisible)}>
                                <MenuIcon />
                            </IconButton>

                            {isVisible && (
                                <h3 style={{ marginLeft: "10px", flexGrow: 1 }}>Report List</h3>
                            )}
                        </Box>

                        {isVisible && (
                            <List>
                                {tabNames.map((name, index) => (
                                    <ListItem
                                        key={index}
                                        button
                                        selected={value === index}
                                        onClick={() => handletabChange(index)}
                                    >
                                        <FolderOpenTwoTone fontSize="medium" style={{ color: "#4dabf7", marginRight: "5px", }} />
                                        <ListItemText primary={name} />
                                    </ListItem>
                                ))}
                            </List>
                        )}
                    </Box>
                    {isVisible && (
                        <Divider
                            orientation="vertical"
                            flexItem
                            sx={{
                                margin: '0 0px',
                                // borderWidth: '0.5px',
                                // borderColor: 'whitesmoke',
                                // height: 'auto',
                            }}
                        />
                    )}
                    {reportStates.Report_All &&
                        <Box flexGrow={1} >
                            <TabContent index={value} />
                        </Box>
                    }

                    {reportStates.Report_SalesOrder &&
                        <Box padding={0} flexGrow={1} >
                            <FinishedParentRollList handleBackWinderMachineEntry={handleViewReport('All Reports', 'Report_All')} />
                        </Box>
                    }

                    {reportStates.Report_FGStock &&
                        <Box padding={0} flexGrow={1} >
                            <FGStockReport handleBackWinderMachineEntry={handleViewReport('All Reports', 'Report_All')} />
                        </Box>
                    }

                    {reportStates.Report_QCData &&
                        <Box padding={0} flexGrow={1} >
                            <QCDataCollection handleBackWinderMachineEntry={handleViewReport('All Reports', 'Report_All')} />
                        </Box>
                    }

                    {reportStates.Report_GenerateQCDataGivenSize &&
                        <Box padding={0} flexGrow={1} >
                            <GenerateQCDataByFilterData handleBackWinderMachineEntry={handleViewReport('All Reports', 'Report_All')} />
                        </Box>
                    }

                    {reportStates.Report_JumboDetailReport &&
                        <Box padding={0} flexGrow={1} >
                            <JumboReport handleBackWinderMachineEntry={handleViewReport('All Reports', 'Report_All')} />
                        </Box>
                    }

                    {reportStates.Report_WIPChildReelDetailReport &&
                        <Box padding={0} flexGrow={1} >
                            <WIPChildReelReport handleBackWinderMachineEntry={handleViewReport('All Reports', 'Report_All')} />
                        </Box>
                    }

                    {reportStates.Report_FGChildReelDetailReport &&
                        <Box padding={0} flexGrow={1} >
                            <FGChildReelReport handleBackWinderMachineEntry={handleViewReport('All Reports', 'Report_All')} />
                        </Box>
                    }

                    {reportStates.Report_SheetCuttingReport &&
                        <Box padding={0} flexGrow={1} >
                            <SheetCuttingReport handleBackWinderMachineEntry={handleViewReport('All Reports', 'Report_All')} />
                        </Box>
                    }

                    {reportStates.Report_ReamBundleReport &&
                        <Box padding={0} flexGrow={1} >
                            <ReamBundleReport handleBackWinderMachineEntry={handleViewReport('All Reports', 'Report_All')} />
                        </Box>
                    }

                    {reportStates.Report_OrderwiseReelPendingConversionReport &&
                        <Box padding={0} flexGrow={1} >
                            <ReelPendingConversionReport handleBackWinderMachineEntry={handleViewReport('All Reports', 'Report_All')} />
                        </Box>
                    }

                    {reportStates.Report_ReamBundlePendingConversionReport &&
                        <Box padding={0} flexGrow={1} >
                            <ReamBundlePendingConversionReport handleBackWinderMachineEntry={handleViewReport('All Reports', 'Report_All')} />
                        </Box>
                    }


                    {reportStates.Report_ChildRollWiseReamProductionReport &&
                        <Box padding={0} flexGrow={1} >
                            <ChildReelWiseReamProductionReport handleBackWinderMachineEntry={handleViewReport('All Reports', 'Report_All')} />
                        </Box>
                    }

                    {reportStates.Report_ParentRollProductionMaWiseBalancePlanQuantity &&
                        <Box padding={0} flexGrow={1} >
                            {/* <ChildReelWiseReamProductionReport handleBackWinderMachineEntry={handleViewReport('All Reports', 'Report_All')} /> */}
                            <ReportParentRollProductionMAWiseBalanceQty handleBackWinderMachineEntry={handleViewReport('All Reports', 'Report_All')} mode={0} />
                        </Box>
                    }

                    {reportStates.Report_ReWinderDetailReport &&
                        <Box padding={0} flexGrow={1} >
                            {/* <ChildReelWiseReamProductionReport handleBackWinderMachineEntry={handleViewReport('All Reports', 'Report_All')} /> */}
                            <ReWinderDetailReport handleBackWinderMachineEntry={handleViewReport('All Reports', 'Report_All')} />
                        </Box>
                    }

                </Box>
            </div>
        </Box>
    )
}
export default ProductionReports